export enum EAudience {
  DealerAndPublic,
  DealerOnly,
}

export enum EPhotoType {
  PassengerSideFrontQuarter,
  FrontDistant,
  DriverSideFrontQuarter,
  DriverSide,
  DriverSideRearQuarter,
  RearDistant,
  PassengerSideRearQuarter,
  PassengerSide,
  TireCloseup,
  Interior,
  Odometer,
  EngineCloseup,
  Other,
}

export enum EBodyStyle {
  Car          = 'Car',
  SUV          = 'SUV',
  Truck        = 'Truck',
  Van          = 'Van',
  Motorcycle   = 'Motorcycle',
  Watercraft   = 'Watercraft',
  ATV          = 'ATV',
  RV           = 'RV',
  Agriculture  = 'Agriculture',
  Construction = 'Construction',
  Other        = 'Other',
}

export enum EConditionType {
  Poor,
  Fair,
  Good,
  Excellent,
}

export enum EAuctionStatus {
  Technical = -1,
  SavedDraft,
  SavedDraftNoPhotos,
  Pending,
  PendingNoPhotos,
  Active,
  Ended,
  Canceled,
  Archived,
  Error,
  Exported,
}

export enum ELocationType {
  Branch,
  OffSite,
}

export enum EBidStatus {
  Waiting,
  IsHighest,
  Outbid,
  Abandoned,
  Winner,
}

export enum EAuctionsPage {
  Search       = 'search',
  NadaAuctions = 'nada-auctions',
}
